<app-modal *ngIf="vo$ | async; let vo" class="app-project-delete-popup">
	<div modal-body>
		<div *ngIf="vo.mode === ProjectDeletePopupMode.UndeletableMode">
			<div>{{ cannotDeleteProject }}</div>
			<div i18n="@@project.delete-popup.cannot-delete-info">
				cannot delete info
			</div>
		</div>
		<mat-stepper
			*ngIf="vo.mode !== ProjectDeletePopupMode.UndeletableMode"
			(selectionChange)="changeCurrentStep($event)"
			[linear]="true">
			<mat-step
				[completed]="confirmDeletion && deleteProjectInput === deleteProject"
				label="confirm deletion"
				i18n-label="@@project.delete-popup.confirm-deletion">
				<div i18n="@@project.delete-popup.description">description</div>
				<dx-data-grid
					[elementAttr]="{
						id: 'project-elements-list',
						class: 'project-elements'
					}"
					[dataSource]="[modalData.project.elements]"
					[showColumnHeaders]="true"
					[showColumnLines]="false"
					[columnAutoWidth]="true"
					[sorting]="false"
					[showBorders]="false">
					<dxo-load-panel
						shadingColor="rgba(0,0,0,0)"
						[indicatorSrc]="DcLoaders.LoaderInfinite"
						[height]="100"
						[width]="100"
						[showIndicator]="true"
						[showPane]="true"
						[shading]="true"></dxo-load-panel>
					<dxi-column
						[dataField]="'publications'"
						caption="publications"
						i18n-caption="@@project.delete-popup.elements.publications"
						[alignment]="'left'"
						cellTemplate="publicationsTemplate"></dxi-column>
					<dxi-column
						[dataField]="'expositions'"
						caption="expositions"
						i18n-caption="@@project.delete-popup.elements.expositions"
						[alignment]="'left'"
						cellTemplate="expositionsTemplate"></dxi-column>
					<dxi-column
						[dataField]="'dashboards'"
						caption="dashboards"
						i18n-caption="@@project.delete-popup.elements.dashboards"
						[alignment]="'left'"
						cellTemplate="dashboardsTemplate"></dxi-column>
					<dxi-column
						[dataField]="'medias'"
						caption="Presentation Handle"
						i18n-caption="@@project.delete-popup.elements.presentationHandle"
						[alignment]="'left'"
						cellTemplate="handleTemplate"></dxi-column>
					<dxi-column
						[dataField]="'exposedDatablocks'"
						caption="exposedDatablocks"
						i18n-caption="@@project.delete-popup.elements.exposedDatablocks"
						[alignment]="'left'"
						cellTemplate="exposedDatablocksTemplate"></dxi-column>
					<dxi-column
						[dataField]="'datablocks'"
						caption="datablocks"
						i18n-caption="@@project.delete-popup.elements.datablocks"
						[alignment]="'left'"
						cellTemplate="datablocksTemplate"></dxi-column>
					<dxi-column
						[dataField]="'entities'"
						caption="entities"
						i18n-caption="@@project.delete-popup.elements.entities"
						[alignment]="'left'"
						cellTemplate="entitiesTemplate"></dxi-column>
					<dxi-column
						[dataField]="'depots'"
						caption="depots"
						i18n-caption="@@project.delete-popup.elements.depots"
						[alignment]="'left'"
						cellTemplate="depotsTemplate"></dxi-column>
					<dxi-column
						[dataField]="'exportTemplates'"
						caption="exportTemplates"
						i18n-caption="@@project.delete-popup.elements.exportTemplates"
						[alignment]="'left'"
						cellTemplate="exportTemplatesTemplate"></dxi-column>
					<dxi-column
						[dataField]="'connectors'"
						caption="connectors"
						i18n-caption="@@project.delete-popup.elements.connectors"
						[alignment]="'left'"
						cellTemplate="connectorsTemplate"></dxi-column>
					<dxi-column
						[dataField]="'formulas'"
						caption="formulas"
						i18n-caption="@@project.delete-popup.elements.formulas"
						[alignment]="'left'"
						cellTemplate="formulasTemplate"></dxi-column>
					<dxi-column
						[dataField]="'rankings'"
						caption="rankings"
						i18n-caption="@@project.delete-popup.elements.rankings"
						[alignment]="'left'"
						cellTemplate="rankingsTemplate"></dxi-column>
					<div *dxTemplate="let cell of 'publicationsTemplate'">
						<ng-container
							[ngTemplateOutlet]="overlayBadge"
							[ngTemplateOutletContext]="{
								$implicit: {
									elements: cell.data['publications'],
									idx: cell.columnIndex,
									label: cell.column.caption
								}
							}"></ng-container>
					</div>
					<div *dxTemplate="let cell of 'expositionsTemplate'">
						<ng-container
							[ngTemplateOutlet]="overlayBadge"
							[ngTemplateOutletContext]="{
								$implicit: {
									elements: cell.data['expositions'],
									idx: cell.columnIndex,
									label: cell.column.caption
								}
							}"></ng-container>
					</div>
					<div *dxTemplate="let cell of 'dashboardsTemplate'">
						<ng-container
							[ngTemplateOutlet]="overlayBadge"
							[ngTemplateOutletContext]="{
								$implicit: {
									elements: cell.data['dashboards'],
									idx: cell.columnIndex,
									label: cell.column.caption
								}
							}"></ng-container>
					</div>
					<div *dxTemplate="let cell of 'handleTemplate'">
						<ng-container
							[ngTemplateOutlet]="overlayBadge"
							[ngTemplateOutletContext]="{
								$implicit: {
									elements: cell.data['handle'],
									idx: cell.columnIndex,
									label: cell.column.caption
								}
							}"></ng-container>
					</div>
					<div *dxTemplate="let cell of 'exposedDatablocksTemplate'">
						<ng-container
							[ngTemplateOutlet]="overlayBadge"
							[ngTemplateOutletContext]="{
								$implicit: {
									elements: cell.data['exposedDatablocks'],
									idx: cell.columnIndex,
									label: cell.column.caption
								}
							}"></ng-container>
					</div>
					<div *dxTemplate="let cell of 'datablocksTemplate'">
						<ng-container
							[ngTemplateOutlet]="overlayBadge"
							[ngTemplateOutletContext]="{
								$implicit: {
									elements: cell.data['datablocks'],
									idx: cell.columnIndex,
									label: cell.column.caption
								}
							}"></ng-container>
					</div>
					<div *dxTemplate="let cell of 'entitiesTemplate'">
						<ng-container
							[ngTemplateOutlet]="overlayBadge"
							[ngTemplateOutletContext]="{
								$implicit: {
									elements: cell.data['entities'],
									idx: cell.columnIndex,
									label: cell.column.caption
								}
							}"></ng-container>
					</div>
					<div *dxTemplate="let cell of 'depotsTemplate'">
						<ng-container
							[ngTemplateOutlet]="overlayBadge"
							[ngTemplateOutletContext]="{
								$implicit: {
									elements: cell.data['depots'],
									idx: cell.columnIndex,
									label: cell.column.caption
								}
							}"></ng-container>
					</div>
					<div *dxTemplate="let cell of 'exportTemplatesTemplate'">
						<ng-container
							[ngTemplateOutlet]="overlayBadge"
							[ngTemplateOutletContext]="{
								$implicit: {
									elements: cell.data['exportTemplates'],
									idx: cell.columnIndex,
									label: cell.column.caption
								}
							}"></ng-container>
					</div>
					<div *dxTemplate="let cell of 'connectorsTemplate'">
						<ng-container
							[ngTemplateOutlet]="overlayBadge"
							[ngTemplateOutletContext]="{
								$implicit: {
									elements: cell.data['connectors'],
									idx: cell.columnIndex,
									label: cell.column.caption
								}
							}"></ng-container>
					</div>
					<div *dxTemplate="let cell of 'formulasTemplate'">
						<ng-container
							[ngTemplateOutlet]="overlayBadge"
							[ngTemplateOutletContext]="{
								$implicit: {
									elements: cell.data['formulas'],
									idx: cell.columnIndex,
									label: cell.column.caption
								}
							}"></ng-container>
					</div>
					<div *dxTemplate="let cell of 'rankingsTemplate'">
						<ng-container
							[ngTemplateOutlet]="overlayBadge"
							[ngTemplateOutletContext]="{
								$implicit: {
									elements: cell.data['rankings'],
									idx: cell.columnIndex,
									label: cell.column.caption
								}
							}"></ng-container>
					</div>
					<ng-template #overlayBadge let-data>
						<span class="no-elements" *ngIf="!data.elements.length">0</span>
						<app-overlay-badge
							*ngIf="data.elements.length"
							[value]="data.elements.length"
							(click)="openedElementOverlay = data.idx"
							[isOpen]="openedElementOverlay === data.idx"
							(overlayDismiss)="openedElementOverlay = undefined">
							<app-popover
								overlayContent
								[label]="data.label"
								[count]="data.elements.length"
								(adbPopoverClose)="openedElementOverlay = undefined">
								<div *ngFor="let element of data.elements">
									<a [href]="element.link">{{ element.label }}</a>
								</div>
							</app-popover>
						</app-overlay-badge>
					</ng-template>
				</dx-data-grid>
				<div class="confirmation-message">
					<span i18n="@@project.delete-popup.confirm">confirm</span>
					<span class="project-title">{{ deleteProject }}</span>
					<span i18n="@@project.delete-popup.in-the-zone">in the field</span>
				</div>

				<mat-form-field
					appearance="outline"
					class="confirmation-message__input">
					<input
						type="text"
						id="{{ cmpId + '-confirm-input' }}"
						[(ngModel)]="deleteProjectInput"
						matInput
						required />
				</mat-form-field>
				<div>
					<mat-checkbox
						id="{{ cmpId }}-confirm-checkbox"
						color="primary"
						[(ngModel)]="confirmDeletion">
						<span i18n="@@project.delete-popup.delete-agree">agree</span>
					</mat-checkbox>
				</div>
			</mat-step>

			<mat-step
				*ngIf="vo.mode === ProjectDeletePopupMode.CriticalMode"
				label="verification code"
				i18n-label="@@project.delete-popup.verification-code">
				<div class="app-project-delete-popup__verification-code-step">
					{{ enterVerificationCode }}
					<div class="verification-code-info">
						<mat-form-field appearance="outline">
							<input
								type="text"
								id="{{ cmpId + '-verification-code-input' }}"
								[(ngModel)]="verificationCode"
								matInput
								required />
						</mat-form-field>
						<a
							i18n="@@project.delete-popup.resend-code"
							(click)="resendVerificationCode()">
							resend code
						</a>
					</div>
				</div>
			</mat-step>
		</mat-stepper>
	</div>

	<div modal-footer class="app-project-delete-popup__footer">
		<ng-container *ngIf="vo.mode !== ProjectDeletePopupMode.UndeletableMode">
			<button
				*ngIf="
					vo.mode === ProjectDeletePopupMode.CriticalMode &&
					vo.currentStep === ProjectDeleteStep.ProjectElements
				"
				id="{{ cmpId }}-next-btn"
				class="app-project-delete-popup__footer__btn"
				mat-raised-button
				(click)="nextStep()"
				[disabled]="!confirmDeletion || deleteProjectInput !== deleteProject"
				color="primary">
				<span i18n="@@general.stepper.next">Next</span>
			</button>
			<button
				*ngIf="vo.currentStep === ProjectDeleteStep.VerificationCode"
				id="{{ cmpId }}-back-btn"
				mat-raised-button
				class="app-project-delete-popup__footer__btn"
				(click)="previousStep()">
				<span i18n="@@general.stepper.back">Back</span>
			</button>
			<button
				*ngIf="
					(vo.mode === ProjectDeletePopupMode.UncriticalMode &&
						vo.currentStep === ProjectDeleteStep.ProjectElements) ||
					(vo.mode === ProjectDeletePopupMode.CriticalMode &&
						vo.currentStep === ProjectDeleteStep.VerificationCode)
				"
				id="{{ cmpId }}-delete-btn"
				class="app-project-delete-popup__footer__btn"
				mat-raised-button
				[disabled]="
					vo.isDeleting ||
					!confirmDeletion ||
					deleteProjectInput !== deleteProject ||
					(vo.currentStep === ProjectDeleteStep.VerificationCode &&
						!verificationCode)
				"
				(click)="delete()"
				color="primary">
				<mat-icon *ngIf="vo.isDeleting">
					<mat-spinner color="accent" [diameter]="20"></mat-spinner>
				</mat-icon>
				<span i18n="@@project.delete-popup.delete-btn">delete project</span>
			</button>
		</ng-container>
		<button
			*ngIf="vo.mode === ProjectDeletePopupMode.UndeletableMode"
			id="{{ cmpId }}-close-btn"
			class="app-project-delete-popup__footer__btn"
			mat-raised-button
			(click)="closePopup()"
			color="primary">
			<span i18n="@@project.delete-popup.close">close</span>
		</button>
	</div>
</app-modal>
